import { PackageSelection } from '../../components/PackageSelection';
import { CustomerSelection } from './CustomerSelection';

export const Pages = [PackageSelection, CustomerSelection] as const;
